import debounce from 'lodash/debounce';

export function useDebounce<M extends (...args: never[]) => unknown>({
  method,
  delay = 500,
}: {
  method: M;
  delay?: number;
}) {
  return debounce(method, delay);
}
